import { createContext } from 'react';

const initialAuthContext: AuthContextStore = {
  username: '',
  userInitials: '',
  profileInfo: {},
  setUserInitials: () => {},
  setProfileInfo: () => {},
};

export const AuthContext = createContext<AuthContextStore>(initialAuthContext);
